import React from 'react';
import { useTranslation } from 'react-i18next';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import './ConsentModal.css';

function ConsentModal({ open, onClose, onAccept, consent, setConsent }) {
    const { t } = useTranslation();
    const handleAccept = () => {
        if (consent) {
            onAccept();
        }
    };

    return (
        <Dialog
            open={open}
            onClose={onClose}
            maxWidth="md"
            fullWidth
            PaperProps={{
                className: 'consent-modal'
            }}
        >
            <DialogTitle className="consent-modal-title">
                {t('loyalty.consent.title')}
            </DialogTitle>
            <DialogContent className="consent-modal-content">
                <Box
                    sx={{
                        color: '#fff',
                        lineHeight: 1.8,
                        '& h3': {
                            color: '#ff6b00',
                            fontSize: '1.2rem',
                            fontWeight: 600,
                            mt: 2,
                            mb: 1
                        },
                        '& h4': {
                            color: '#ff8c33',
                            fontSize: '1rem',
                            fontWeight: 600,
                            mt: 1.5,
                            mb: 0.5
                        },
                        '& p': {
                            mb: 1.5
                        },
                        '& ul': {
                            pl: 3,
                            mb: 1.5
                        },
                        '& li': {
                            mb: 0.5
                        },
                        '& strong': {
                            color: '#ff6b00'
                        },
                        maxHeight: '60vh',
                        overflowY: 'auto',
                        pr: 2
                    }}
                    dangerouslySetInnerHTML={{ __html: t('loyalty.consent.description') }}
                />

                <Box sx={{ mt: 3 }}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                checked={consent}
                                onChange={(e) => setConsent(e.target.checked)}
                                sx={{
                                    color: '#ff6b00',
                                    '&.Mui-checked': {
                                        color: '#ff6b00',
                                    },
                                }}
                            />
                        }
                        label={
                            <Typography variant="body1" sx={{ color: '#fff', fontWeight: 500 }}>
                                {t('loyalty.consent.agreeLabel')}
                            </Typography>
                        }
                    />
                </Box>
            </DialogContent>
            <DialogActions className="consent-modal-actions">
                <Button
                    onClick={onClose}
                    sx={{
                        color: 'rgba(255, 255, 255, 0.7)',
                        '&:hover': {
                            bgcolor: 'rgba(255, 255, 255, 0.1)'
                        }
                    }}
                >
                    {t('loyalty.consent.cancel')}
                </Button>
                <Button
                    onClick={handleAccept}
                    disabled={!consent}
                    variant="contained"
                    sx={{
                        bgcolor: '#ff6b00',
                        color: '#fff',
                        '&:hover': {
                            bgcolor: '#ff8c33'
                        },
                        '&:disabled': {
                            bgcolor: 'rgba(255, 107, 0, 0.3)',
                            color: 'rgba(255, 255, 255, 0.3)'
                        }
                    }}
                >
                    {t('loyalty.consent.accept')}
                </Button>
            </DialogActions>
        </Dialog>
    );
}

export default ConsentModal;
